import { combineReducers } from 'redux';
import { fileUploadRootReducer } from './fileUploadRootReducer';
import { fileUploadProgressRootReducer } from './fileUploadProgressRootReducer';
import { fileUploadModalRootReducer } from './fileUploadModalRootReducer';
import { fileUploadModalMaxSizeReducer } from './fileUploadModalMaxSizeReducer';
import { fileUploadSuccessRootReducer } from './fileUploadSuccessRootReducer';
export const fileRootReducer = combineReducers({
    fileInfo: fileUploadRootReducer,
    fileUploadProgress: fileUploadProgressRootReducer,
    fileUploadSuccess: fileUploadSuccessRootReducer,
    fileUploadModal: fileUploadModalRootReducer,
    fileUploadMaxSize: fileUploadModalMaxSizeReducer
});
//# sourceMappingURL=fileRootReducer.js.map